import { useLayoutEffect } from "react";

const blockers = new Set<() => boolean>();

export const canRefreshApp = () =>
  !Array.from(blockers).some((shouldBlock) => shouldBlock());

// Saves and uploads can outlive their component, so their blocker is released
// by the operation's finally block rather than by React's unmount cleanup.
export const blockAppRefresh = (shouldBlock: () => boolean = () => true) => {
  blockers.add(shouldBlock);
  return () => {
    blockers.delete(shouldBlock);
  };
};

export const useAppRefreshBlocker = (shouldBlock: () => boolean) => {
  useLayoutEffect(() => blockAppRefresh(shouldBlock), [shouldBlock]);
};
